const navLinks = [
    { href: '/language', label: 'Language' },
    { href: '/examples', label: 'Tools' },
    { href: '/showcase', label: 'Showcase' },
]

export function LandingHeader() {
    const path = window.location.pathname

    return (
        <header
            className="fixed top-0 left-0 right-0 z-50"
            style={{
                background: 'color-mix(in srgb, var(--bg) 80%, transparent)',
                backdropFilter: 'blur(20px) saturate(1.5)',
                borderBottom: '1px solid color-mix(in srgb, var(--border) 50%, transparent)',
            }}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 h-14 sm:h-16 flex items-center justify-between">
                <a href="/" className="font-mono text-accent font-bold text-base sm:text-lg tracking-tight">
                    EN
                </a>

                <nav className="flex items-center gap-3 sm:gap-6">
                    {navLinks.map((link) => (
                        <a
                            key={link.href}
                            href={link.href}
                            className={`text-[10px] font-bold font-mono uppercase tracking-widest transition-colors ${
                                path === link.href
                                    ? 'text-text'
                                    : 'text-text-muted hover:text-text'
                            }`}
                        >
                            {link.label}
                        </a>
                    ))}
                </nav>
            </div>
        </header>
    )
}
